import { render, staticRenderFns } from "./TableCellOrderItemsTitle.vue?vue&type=template&id=7dea64ea&scoped=true"
import script from "./TableCellOrderItemsTitle.vue?vue&type=script&lang=js"
export * from "./TableCellOrderItemsTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dea64ea",
  null
  
)

export default component.exports